// 공통 스켈레톤 — 콜드 로딩 시 빈화면 대신 회색 펄스 골격(#1·#5)
// 캐시 hit(peekCache≠null) 시엔 loading=false라 안 보임 → 진짜 콜드일 때만 노출.
// 색은 기존 토큰(--cs-line·--cs-surface)만. reduced-motion이면 정적(펄스 off).
import type { CSSProperties } from 'react';

// 펄스 keyframes + reduced-motion 가드 — 모듈당 1회 주입(LoadingState/fmFx 패턴)
let injected = false;
function ensureCss() {
  if (injected || typeof document === 'undefined') return;
  injected = true;
  const el = document.createElement('style');
  el.textContent =
    '@keyframes cs-skeleton-pulse{0%,100%{opacity:.5}50%{opacity:.9}}' +
    '@media (prefers-reduced-motion: reduce){.cs-skeleton{animation:none!important}}';
  document.head.appendChild(el);
}

type SkeletonProps = {
  w?: number | string; // 너비(기본 100%)
  h?: number | string; // 높이(기본 16px)
  r?: number;          // 모서리 둥글기(기본 6)
  style?: CSSProperties;
};

export function Skeleton({ w = '100%', h = 16, r = 6, style = {} }: SkeletonProps) {
  ensureCss();
  return (
    <div
      aria-hidden
      className="cs-skeleton"
      style={{
        width: w,
        height: h,
        borderRadius: r,
        background: 'var(--cs-line)',
        animation: 'cs-skeleton-pulse 1.3s ease-in-out infinite',
        ...style,
      }}
    />
  );
}

// 카드 골격 — 여러 줄 스켈레톤 묶음(보유종목 등 리스트 placeholder용)
// ⚠ 2026-07-26: border 1px → 그림자로 교체. 실제 카드(CSCard)는 테두리 없이 그림자로 뜨는데
//   스켈레톤만 테두리라, 로딩이 끝나는 순간 카드 경계 표현이 바뀌며 시각적으로 튀었다.
//   docs/design.md §G-2(테두리 제거 · 경계는 명도 대비 + 그림자)와도 어긋났다.
export function SkeletonCard({ lines = 2 }: { lines?: number }) {
  return (
    <div
      style={{
        background: 'var(--cs-surface)',
        boxShadow: 'var(--cs-shadow-1)',
        borderRadius: 14,
        padding: 14,
        display: 'flex',
        flexDirection: 'column',
        gap: 9,
      }}
    >
      <Skeleton w="42%" h={13} />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} w={i === lines - 1 ? '66%' : '100%'} h={12} />
      ))}
    </div>
  );
}
